// Application routes
export const ROUTES = {
  HOME: '/',

  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  FORGOT_PASSWORD: '/auth/forgot-password',
  OAUTH_CALLBACK: '/auth/callback',

  // Dashboard
  DASHBOARD: '/dashboard',

  // Leads
  LEADS: '/leads',
  LEAD_DETAILS: (id: string) => `/leads/${id}`,
  NEW_LEAD: '/leads/new',

  // Analytics
  ANALYTICS: '/analytics',
  REPORTS: '/analytics/reports',

  // Integrations
  INTEGRATIONS: '/integrations',
  INTEGRATION_DETAIL: (id: string) => `/integrations/${id}`,

  // Notifications
  NOTIFICATIONS: '/notifications',

  // Scrapers
  SCRAPERS: '/scrapers',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_COMPANY: '/settings/company',
  SETTINGS_BILLING: '/settings/billing',
  SETTINGS_TEAM: '/settings/team',

  // Support
  SUPPORT: '/support',
  TICKET_DETAILS: (id: string) => `/support/${id}`,

  // Errors
  NOT_FOUND: '*',
} as const;
